import api from "./api-service";

export const findAll = () => {
  return api().get("roles/admin");
};
